import React, { useEffect, useState, useContext } from "react";
import { Button, Modal, Form as AntForm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Form, MainTable } from "components";
import { instance } from "utils/axios";
import fields from "./fields";
import { AuthContext } from "contexts";

function Room() {
  const authContext = useContext(AuthContext);
  const { action } = authContext;
  const [data, setData] = useState([]);
  const [wards, setWards] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = AntForm.useForm();
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    action.handleSidebarKey("room");
    instance({
      method: "get",
      url: `/wards`,
    })
      .then((res) => {
        setWards(
          res.data.map((item) => ({
            ...item,
            value: item.id,
            label: item.name,
          }))
        );
        fetchData();
      })
      .catch((err) => {})
      .then(() => setLoading(false));
  }, []);
  const fetchData = () => {
    setLoading(true);
    instance({
      method: "get",
      url: `/rooms`,
    })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {})
      .then(() => setLoading(false));
  };

  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "No",
      width: 40,
      align: "center",
      render: (text, row, i) => <span>{currentPage + i + 1}</span>,
    },
    {
      title: "Тасгийн нэр",
      dataIndex: "wardName",
      key: "wardName",
    },
    {
      title: "Өрөөний дугаар",
      dataIndex: "room_number",
      key: "room_number",
    },
    {
      title: "Тайлбар",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: 80,
      render: (text, row) => (
        <div className="flex items-center gap-5">
          <Button size="small" onClick={() => handleEdit(row)}>
            <div className="flex items-center gap-2">
              <EditOutlined /> Засах
            </div>
          </Button>
        </div>
      ),
    },
  ];

  const handleSubmit = (values) => {
    setLoading(true);
    if (editData.id) {
      instance({
        method: "put",
        url: "/room",
        data: {
          ...values,
          id: editData.id,
        },
      })
        .then((res) => {
          handleCloseModal();
          fetchData();
        })
        .catch((err) => {})
        .then(() => setLoading(false));
    } else {
      instance({
        method: "post",
        url: "/room",
        data: {
          ...values,
        },
      })
        .then((res) => {
          handleCloseModal();
          fetchData();
        })
        .catch((err) => {})
        .then(() => setLoading(false));
    }
  };

  const handleAdd = () => {
    setIsEdit(true);
    setEditData({
      id: null,
    });
    setOpen(true);
  };

  const handleEdit = (row) => {
    setEditData(row);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    form.resetFields();
  };

  return (
    <div className="flex flex-col px-4 pb-4">
      <MainTable
        dataTable={data}
        columns={columns}
        setCurrentPage={setCurrentPage}
        loading={loading}
        pagination={true}
        title={"Өрөө"}
        handleAdd={handleAdd}
        handleRefresh={fetchData}
      />
      <Modal
        title={editData ? "Өрөө мэдээлэл засах" : "Өрөө нэмэх"}
        open={open}
        destroyOnClose
        width={1000}
        okText="Хадгалах"
        confirmLoading={loading}
        onOk={form.submit}
        onCancel={loading ? null : handleCloseModal}
        cancelButtonProps={{ disabled: loading }}
      >
        <Form
          form={form}
          fields={fields({ wards })}
          layout="vertical"
          onFinish={handleSubmit}
          editData={editData}
          isEdit={isEdit}
          className="gap-4"
        />
      </Modal>
      {contextHolder}
    </div>
  );
}

export default Room;
